// Website / portal entry. No frappe.boot here, so we may need to fetch
// the config from the public API on first load.
import { getConfig, getMergedTextReplacements } from "./modules/config";
import { installTextReplacer } from "./modules/text_replacer";
import { installLinkBlocker } from "./modules/link_blocker";
import { installTheme } from "./modules/theme";

async function start() {
	let config = getConfig();
	if (!config || !config.enabled) {
		try {
			const res = await fetch("/api/method/white_label.api.branding.get_config", { credentials: "same-origin" });
			const json = await res.json();
			config = json.message || { enabled: false };
			window.white_label = config;
		} catch (e) {
			return;
		}
	}
	if (!config.enabled) return;

	installTheme(config.theme);

	installTextReplacer(getMergedTextReplacements(config), {
		scan_text_nodes: config.text_policy?.scan_text_nodes,
		scan_attributes: config.text_policy?.scan_attributes,
		scan_titles_and_meta: config.text_policy?.scan_titles_and_meta,
	});

	installLinkBlocker(config.url_policy || {});

	const assets = config.assets || {};
	if (assets.favicon) {
		document.querySelectorAll("link[rel~='icon'], link[rel='shortcut icon']").forEach((l) => l.setAttribute("href", assets.favicon));
	}
	if (assets.logo) {
		document.querySelectorAll(".navbar-brand img, .website-logo img, img.brand-image").forEach((img) => img.setAttribute("src", assets.logo));
	}

	const css = (config.advanced && config.advanced.custom_css) || "";
	if (css) {
		const s = document.createElement("style");
		s.dataset.wl = "custom";
		s.textContent = css;
		document.head.appendChild(s);
	}
}

if (document.readyState === "loading") {
	document.addEventListener("DOMContentLoaded", start);
} else {
	start();
}
